export const PROFILE_SECTIONS = [
  { id: 'contact', title: 'Contact & personal', fields: [
    ['full_name', 'Full name'], ['phone', 'Phone', 'tel'], ['email', 'Email', 'email'],
    ['whatsapp_number', 'WhatsApp number', 'tel'], ['whatsapp_same_as_phone', 'WhatsApp same as phone?', ['Yes', 'No']],
    ['date_of_birth', 'Date of birth', 'date'],
  ]},
  { id: 'study', title: 'Study preferences', fields: [
    ['desired_country', 'Country of interest', 'country'], ['desired_course', 'Course', 'program'],
    ['intake_id', 'Intake', 'intake'], ['university_selected', 'University', 'university'],
    ['interested_country_finalised', 'Country finalised?', ['Yes', 'No', 'Exploring Options']],
    ['lead_quality', 'Interest level', ['Hot', 'Warm', 'Cold']],
  ]},
  { id: 'education', title: 'Education & work', fields: [
    ['highest_qualification', 'Highest qualification', ['10th', '12th', 'Diploma', "Bachelor's", "Master's", 'PhD']],
    ['course_studied', 'Course / stream'], ['percentage_cgpa', 'Marks / CGPA'], ['year_of_passing', 'Passing year'],
    ['current_status', 'Current status', ['Studying', 'Studying in 12th', 'Passed 12th', 'Working', 'Gap Year', 'Completed Education']],
    ['current_employer', 'Employer'], ['work_experience_years', 'Experience (years)'],
  ]},
  { id: 'guardian', title: 'Guardian & availability', fields: [
    ['parent_name', 'Parent / guardian'], ['parent_phone', 'Guardian phone', 'tel'],
    ['speaking_with', 'Speaking with', ['Student', 'Parent', 'Guardian', 'Sibling', 'Other']],
    ['preferred_counselling_time', 'Preferred counselling time'],
  ]},
  { id: 'address', title: 'Address', fields: [
    ['address', 'Street address'], ['city', 'City'], ['state', 'State'],
  ]},
  { id: 'english', title: 'English language test', fields: [
    ['english_test_status', 'Test status', ['IELTS Taken', 'PTE Taken', 'TOEFL Taken', 'Duolingo Taken', 'Not Taken']],
    ['english_test_score', 'Score'], ['planning_to_take_test', 'Planning a test?', ['Yes', 'No']],
    ['expected_test_date', 'Expected test date'],
  ]},
  { id: 'funding', title: 'Study funding', fields: [
    ['study_budget', 'Budget', ['Below 10 Lakhs', '10-20 Lakhs', '20-30 Lakhs', '30-50 Lakhs', 'Above 50 Lakhs']],
    ['education_loan_required', 'Education loan?', ['Yes', 'No', 'Maybe']],
    ['sponsor', 'Sponsor', ['Self', 'Father', 'Mother', 'Parent', 'Relative', 'Scholarship', 'Loan']],
  ]},
  { id: 'passport', title: 'Passport & document readiness', fields: [
    ['passport_available', 'Passport available?', ['Yes', 'No', 'Applied']],
    ['passport_number', 'Passport number'], ['passport_expiry_date', 'Passport expiry', 'date'],
    ['documents_ready', 'Documents ready?', ['Yes', 'Partially', 'No']],
  ]},
];

export const displayValue = (student, key) => key === 'intake_id' ? student.intake || '' : student[key];
export const humanize = (value) => String(value || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
export const displayDate = (value) => {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(`${value}T12:00:00+05:30`).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata', dateStyle: 'medium' });
  }
  if (!value || Number.isNaN(new Date(value).getTime())) return 'Date not recorded';
  return new Date(value).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
};